"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const redux_actions_1 = require("redux-actions");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const errors_1 = require("data/aggErrors/errors");
const actions_1 = require("data/institutionLogins/actions");
const actions = __importStar(require("./actions"));
const types_1 = require("./types");
const getDataForScope = (state, scope) => {
    assert(scope, 'Cannot access InstitutionLoginUpserterisAuthenticationDoneStore without a scope');
    return state.upserterData.get(scope);
};
const setDataForScope = (state, scope, data) => {
    assert(scope, 'Cannot access InstitutionLoginUpserterStore without a scope');
    return state.set('upserterData', state.upserterData.set(scope, data));
};
const mergeDataForScope = (state, scope, data) => {
    var _a;
    assert(scope, 'Cannot access InstitutionLoginUpserterStore without a scope');
    return setDataForScope(state, scope, ((_a = assert(getDataForScope(state, scope), 'can not get data for scope (mergeDataForScope)')) !== null && _a !== void 0 ? _a : (0, types_1.mkInstitutionLoginUpserterData)())
        .merge(data));
};
exports.reducer = (0, redux_actions_1.handleActions)({
    [actions.accountDiscoverySetup]: (state, { payload, meta: { scope } }) => setDataForScope(state, scope, (0, types_1.mkInstitutionLoginUpserterData)(payload)),
    [actions.accountDiscoveryCleanup]: (state, { meta: { scope } }) => state.set('upserterData', state.upserterData.remove(scope)),
    [actions.institutionSelected]: (state, { payload: { channel, institution }, meta: { scope } }) => {
        const data = getDataForScope(state, scope);
        const institutionLogin = (data === null || data === void 0 ? void 0 : data.institutionLogin) ? data === null || data === void 0 ? void 0 : data.institutionLogin.set('institutionId', institution.id) : null;
        return mergeDataForScope(state, scope, { channel, institution, institutionLogin });
    },
    [actions.accountDiscoveryCredentialsFormSubmit]: (state, { meta: { scope } }) => mergeDataForScope(state, scope, {
        error: false,
        isSubmitting: true,
    }),
    [actions.accountDiscoveryCredentialsFormSubmitResponse]: {
        next(state, { payload: { institutionLogin }, meta: { scope } }) {
            return mergeDataForScope(state, scope, {
                institutionLogin,
                isPolling: true,
                isSubmitting: false,
            });
        },
        throw(state, { meta: { scope } }) {
            return mergeDataForScope(state, scope, { isSubmitting: false });
        },
    },
    [actions.accountDiscoveryMfaRequired]: (state, { payload: { mfaChallenge }, meta: { scope } }) => mergeDataForScope(state, scope, {
        mfaChallenge,
        isPolling: false,
        isSubmitting: false,
    }),
    [actions.accountDiscoveryMfaFormSubmit]: (state, { meta: { scope } }) => mergeDataForScope(state, scope, {
        error: null,
        isSubmitting: true,
    }),
    [actions.accountDiscoveryMfaFormSubmitResponse]: {
        next(state, { meta: { scope } }) {
            return mergeDataForScope(state, scope, {
                mfaChallenge: null,
                isPolling: true,
                isSubmitting: false,
            });
        },
        throw(state, { meta: { scope } }) {
            return mergeDataForScope(state, scope, {
                mfaChallenge: null,
                isSubmitting: false,
            });
        },
    },
    [actions.getPartnerAuthUris]: (state, { meta: { scope } }) => mergeDataForScope(state, scope, {
        error: false,
    }),
    [actions.getPartnerAuthUrisSuccess]: (state, { payload: { partnerAuthUris }, meta: { scope } }) => mergeDataForScope(state, scope, {
        partnerAuthUris,
    }),
    [actions.getPartnerAuthUrisFailure]: (state, { payload: { error }, meta: { scope } }) => {
        var _a, _b, _c, _d, _e;
        const status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
        const code = (_e = (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.code;
        // const description = payload?.response?.data?.errors?.[0]?.description;
        return mergeDataForScope(state, scope, {
            error: {
                error: status,
                title: 'This Bank is not available right now',
                text: 'This Bank is not available right now.',
                status,
                statusCode: code,
                code: null,
                // actionLabel: 'Try Again',
                // action: refreshAccounts({ institutionLoginId: institutionLogin.id }),
                // showConfirmationDialog: true,
                // institutionLogin,
            },
        });
    },
    [actions.accountDiscoverySuccessWithAccounts]: (state, { payload, meta: { scope }, asyncDispatch }) => {
        const { institutionLogin, accountDiscoveryData } = payload;
        if (accountDiscoveryData.credentialsBlob) {
            asyncDispatch((0, actions_1.institutionLoginSetCredentialsBlob)({
                institutionLoginId: accountDiscoveryData === null || accountDiscoveryData === void 0 ? void 0 : accountDiscoveryData.institutionLoginId,
                credentialsBlob: accountDiscoveryData.credentialsBlob,
            }));
        }
        return mergeDataForScope(state, scope, {
            institutionLogin,
            accountDiscoveryData,
            isAuthenticationDone: true,
            isPolling: false,
            isSubmitting: false,
        });
    },
    [actions.accountDiscoverySuccess]: (state, { payload: { institutionLogin }, meta: { scope } }) => mergeDataForScope(state, scope, {
        institutionLogin,
        isAuthenticationDone: true,
        isPolling: false,
        isSubmitting: false,
    }),
    [actions.accountDiscoveryFailure]: (state, { payload: { adStatus, institutionLogin, isWebFirstDataset }, meta: { scope } }) => {
        let error = null;
        if (adStatus.status === 'AGGREGATOR_IN_ERROR') {
            const aggregator = adStatus.aggregators.get(0);
            if (aggregator) {
                const { aggStatus, cpAggStatusCode, userInstructions } = aggregator;
                error = (0, errors_1.getQcsAggregationAction)(institutionLogin, aggStatus, cpAggStatusCode, feature_flags_1.featureFlagsSelectors.dangerouslyUseFeatureFlags(), userInstructions && new Error(userInstructions), isWebFirstDataset);
            }
        }
        return mergeDataForScope(state, scope, {
            institutionLogin,
            error,
            isPolling: false,
            isSubmitting: false,
        });
    },
    [actions.accountDiscoveryError]: (state, { payload: { institutionLogin, error, isWebFirstDataset }, meta: { scope } }) => {
        var _a, _b, _c, _d, _e;
        const aggStatus = (error === null || error === void 0 ? void 0 : error.aggStatus) || ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status);
        const aggStatusCode = (error === null || error === void 0 ? void 0 : error.aggStatusCode) || ((_e = (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.code);
        const aggAction = (0, errors_1.getQcsAggregationAction)(institutionLogin, aggStatus, aggStatusCode, feature_flags_1.featureFlagsSelectors.dangerouslyUseFeatureFlags(), error, isWebFirstDataset);
        return mergeDataForScope(state, scope, {
            institutionLogin,
            error: aggAction,
            isPolling: false,
            isSubmitting: false,
        });
    },
    [actions.accountDiscoveryStopped]: (state, { meta: { scope } }) => mergeDataForScope(state, scope, {
        isPolling: false,
        isSubmitting: false,
    }),
    [actions.accountDiscoveryWidgetUpdateSuccess]: (state, { payload: { institutionLogin, accountDiscoveryData }, meta: { scope } }) => mergeDataForScope(state, scope, {
        institutionLogin,
        accountDiscoveryData,
        isAuthenticationDone: true,
    }),
    [actions.discoverInstitutionLoginWithAccounts]: (state, { payload: { institutionLogin }, meta: { scope } }) => mergeDataForScope(state, scope, {
        institutionLogin,
        isSubmitting: true,
    }),
    [actions.discoverInstitutionLoginWithAccountsResponse]: {
        next(state, { payload: { institutionLogin, accountDiscoveryData, updateStrategy = 'UPDATE' }, meta: { scope } }) {
            // If we haven't got an institutionId in the institutionLogin (we won't if new login), then
            // use one in current state object.
            //
            const data = getDataForScope(state, scope);
            const mergedInstitutionLogin = !institutionLogin.institutionId
                ? institutionLogin.set('institutionId', data.institutionId)
                : institutionLogin;
            return mergeDataForScope(state, scope, {
                institutionLogin: mergedInstitutionLogin,
                accountDiscoveryData,
                updateStrategy,
                isAuthenticationDone: true,
                isSubmitting: false,
            });
        },
        throw(state, { meta: { scope } }) {
            return mergeDataForScope(state, scope, {
                isSubmitting: false,
            });
        },
    },
    [actions.discoverInstitutionLoginWithAccountsDiscard]: (state, { _payload, meta: { scope } }) => mergeDataForScope(state, scope, {
        institutionLogin: null,
        isSubmitting: false,
    }),
    [actions_1.addInstitutionLoginAndAccountsResponse]: {
        next(state, { payload: { institutionLogin }, meta: { scope } }) {
            return mergeDataForScope(state, scope, {
                institutionLogin,
                isAccountUpsertingDone: true,
                isSubmitting: false,
            });
        },
        throw(state, { meta: { scope } }) {
            return mergeDataForScope(state, scope, {
                isSubmitting: false,
            });
        },
    },
    [actions_1.refreshAccountsCredentialsProvided]: (state, { meta: { scope } }) => {
        if (!scope)
            return state;
        return mergeDataForScope(state, scope, { isAuthenticationDone: true });
    },
    [actions_1.refreshAccountsMfaFormSubmitResponse]: {
        next(state, { payload: { institutionLoginId }, meta: { scope } }) {
            if (!scope)
                return state;
            const data = getDataForScope(state, scope);
            if ((data === null || data === void 0 ? void 0 : data.institutionLogin) && (data === null || data === void 0 ? void 0 : data.institutionLogin.id) === institutionLoginId) {
                return mergeDataForScope(state, scope, { isAuthenticationDone: true });
            }
            return state;
        },
    },
    [(0, redux_actions_1.combineActions)(accounts_1.accountsActions.batchAccountsSuccess, accounts_1.accountsActions.batchAccountsFailure).toString()]: (state, { meta: { scope } }) => {
        if (!scope)
            return state;
        return mergeDataForScope(state, scope, {
            isAccountUpsertingDone: true,
            isSubmitting: false,
        });
    },
}, (0, types_1.mkInstitutionLoginUpserterStore)());
exports.default = exports.reducer;
